import type { KyInstance } from 'ky';
import type {
  StartSupportSessionRequest,
  SupportSessionAccessResponse,
  SupportSessionResponse,
} from './types';

const base = 'api/v1/admin/support-sessions';

/**
 * Support-Sitzungen des Plattform-Admins. Der Server nimmt sie nur aus der Heimatsitzung an; der
 * Auth-Store ruft sie deshalb über den Client der Heimatsitzung auf, nie mit dem Support-Token.
 */
export function buildSupportSessionApi(http: KyInstance) {
  return {
    start: (body: StartSupportSessionRequest) =>
      http.post(base, { json: body }).json<SupportSessionAccessResponse>(),
    issueToken: (sessionId: string) =>
      http.post(`${base}/${sessionId}/token`).json<SupportSessionAccessResponse>(),
    end: (sessionId: string) => http.post(`${base}/${sessionId}/end`).then(() => undefined),
    current: async (): Promise<SupportSessionResponse | null> => {
      const response = await http.get(`${base}/current`);
      return response.status === 204 ? null : response.json<SupportSessionResponse>();
    },
  };
}

export type SupportSessionApi = ReturnType<typeof buildSupportSessionApi>;
